// Color schemes for asset plan dashboard charts
export const ASSET_PLAN_COLORS = {
  general: {
    totalinterventioncost: '#FEA41D',
    totalassetplanitems: '#1D8AFE',
    priority1cost: '#FC533E',
    priority1assetplanitems: '#25CF3F',
  },

  assetMetrics: {
    totalreplacementcost: '#FEA41D',
    priority1assetsreplacementcost: '#FC533E',
    totalassetcount: '#1D8AFE',
    priority1assetcount: '#25CF3F',
  },

  findingsMetrics: {
    findingstotalinterventioncost: '#14B8A6',
    totalfindingscount: '#8B5CF6',
    deferredfindingscost: '#EC4899',
    deferredfindingscount: '#3B82F6',
  },

  interventionCostByPriority: {
    priority1: '#FC533E',
    priority2: '#FEA41D',
    priority3: '#1D8AFE',
  },
} as const;

export type AssetPlanColors = typeof ASSET_PLAN_COLORS;
